import View from './View';

export { default as getPackshotGridStyles } from './styles';
export { default as View } from './View';
export * from './types';
export const useViewModel = (props) => props;

export default View;
